import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { API_INVENTORY_URL } from '@/utils';
import { BrandApi } from '../models';

const brandsService = createApi({
  reducerPath: 'brandsService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/brands`),
  tagTypes: ['Brands'],
  endpoints: (builder) => ({
    getBrands: builder.query<
      PaginatedResponse<BrandApi>,
      { paginated: PaginatedRequest; search?: string }
    >({
      query: ({ paginated, search }) => {
        const params: any = {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        };

        if (search && search.trim() !== '') {
          params.name = search.trim();
        }

        return {
          url: '',
          params,
        };
      },
      providesTags: ['Brands'],
    }),
    createBrand: builder.mutation<BrandApi, { name: string }>({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Brands'],
    }),
    getBrandById: builder.query<BrandApi, { brandId: string }>({
      query: ({ brandId }) => ({
        url: `/${brandId}`,
      }),
      providesTags: ['Brands'],
    }),
    updateBrand: builder.mutation<
      BrandApi,
      { brandId: string; body: Partial<BrandApi> }
    >({
      query: ({ brandId, body }) => ({
        url: `/${brandId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Brands'],
    }),
  }),
});

export default brandsService;
export const {
  useGetBrandsQuery,
  useCreateBrandMutation,
  useUpdateBrandMutation,
  useGetBrandByIdQuery,
} = brandsService;
